var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClients = function SvgClients(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.746 15.124c1.392.69 2.586 1.799 3.457 3.185.172.275.259.412.288.602.061.386-.206.86-.57 1.014-.18.075-.381.075-.784.075m-4.303-8.942a4.245 4.245 0 0 0 2.39-3.808 4.246 4.246 0 0 0-2.39-3.808M13.922 7.25c0 2.347-1.927 4.25-4.303 4.25S5.317 9.597 5.317 7.25 7.243 3 9.619 3c2.377 0 4.303 1.903 4.303 4.25ZM2.983 18.053c1.525-2.26 3.93-3.72 6.636-3.72 2.707 0 5.112 1.46 6.637 3.72.333.495.5.743.481 1.06a1.043 1.043 0 0 1-.377.696c-.256.191-.608.191-1.312.191H4.19c-.704 0-1.056 0-1.312-.191-.2-.149-.363-.45-.378-.697-.019-.316.148-.564.482-1.06Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
};
export default SvgClients;